<div class="user-cloud-drive-content">
    <p class="cc-text-required" *ngIf="isUrlNotAvailable">
        <strong>Cloud drive url not available</strong>
    </p>
</div>
